(() => {
  if (window.skinnovationFormsV1) return;
  window.skinnovationFormsV1 = true;

  function postSubmission(endpoint, data, timeoutMessage) {
    return new Promise((resolve, reject) => {
      let url;
      try {
        url = new URL(endpoint);
        if (url.origin !== 'https://script.google.com' || !/^\/macros\/s\/[A-Za-z0-9_-]+\/exec$/.test(url.pathname)) throw new Error('Ongeldig formulier-endpoint.');
      } catch (error) { reject(error); return; }
      const iframe = document.createElement('iframe');
      const form = document.createElement('form');
      const frameName = 'sk-submit-' + crypto.randomUUID();
      iframe.name = frameName;
      iframe.hidden = true;
      iframe.setAttribute('aria-hidden', 'true');
      iframe.title = 'Formulierbevestiging';
      form.hidden = true;
      form.method = 'POST';
      form.action = url.href;
      form.target = frameName;
      form.enctype = 'application/x-www-form-urlencoded';
      const fields = { payload: JSON.stringify(data), request_token: data.request_token, parent_origin: location.origin, response_mode: 'iframe' };
      Object.entries(fields).forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = name; input.value = value;
        form.append(input);
      });
      let timer;
      const cleanup = () => {
        clearTimeout(timer);
        window.removeEventListener('message', receive);
        form.remove(); iframe.remove();
      };
      const receive = event => {
        let origin;
        try { origin = new URL(event.origin); } catch { return; }
        if (origin.protocol !== 'https:' || !(origin.hostname === 'script.google.com' || origin.hostname === 'script.googleusercontent.com' || origin.hostname.endsWith('.script.googleusercontent.com') || origin.hostname.endsWith('-script.googleusercontent.com'))) return;
        const result = event.data;
        if (!result || result.channel !== 'skinnovation-submit-v1' || result.request_token !== data.request_token || result.form_type !== data.form_type) return;
        cleanup();
        if (result.ok === true && result.registration_id === data.request_token) resolve(result);
        else {
          const error = new Error(result.error || timeoutMessage);
          error.fieldErrors = result.field_errors || {};
          reject(error);
        }
      };
      window.addEventListener('message', receive);
      timer = setTimeout(() => { cleanup(); reject(new Error(timeoutMessage)); }, 45000);
      document.body.append(iframe, form);
      try { HTMLFormElement.prototype.submit.call(form); }
      catch (error) { cleanup(); reject(error); }
    });
  }

  async function submissionToken(data, key) {
    const bytes = new TextEncoder().encode(JSON.stringify(data));
    const digest = await crypto.subtle.digest('SHA-256', bytes);
    const fingerprint = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
    let previous;
    try { previous = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch {}
    const token = previous && previous.fingerprint === fingerprint && typeof previous.token === 'string' ? previous.token : crypto.randomUUID();
    try { sessionStorage.setItem(key, JSON.stringify({ fingerprint, token })); } catch {}
    return token;
  }

  function init(section) {
    if (section.dataset.skInitialized) return;
    section.dataset.skInitialized = 'true';
    const form = section.querySelector('[data-sk-form]');
    const status = section.querySelector('[data-sk-status]');
    const button = section.querySelector('[data-sk-submit]');
    if (!form || !status || !button) return;
    const label = button.querySelector('span');
    const buttonLabel = label.textContent;
    const actionInput = form.querySelector('[data-sk-action]');
    const rankFields = Array.from(form.querySelectorAll('[data-sk-rank]'));
    const email = form.elements.namedItem('email');
    const contact = form.elements.namedItem('contact_opnemen');
    const mode = () => {
      if (!actionInput || section.dataset.formType !== 'attendance') return;
      actionInput.value = new URLSearchParams(location.search).get('actie') === 'uitchecken' ? 'Uitchecken' : 'Inchecken';
      section.querySelector('[data-sk-mode]').textContent = actionInput.value;
    };
    const updateRanks = () => {
      const chosen = rankFields.map(field => field.value).filter(Boolean);
      rankFields.forEach(field => Array.from(field.options).forEach(option => { option.disabled = option.value !== field.value && chosen.includes(option.value); }));
    };
    const contactRequired = () => { if (contact && email) email.required = contact.value === 'ja'; };
    const clearErrors = () => {
      form.querySelectorAll('[data-sk-field-error]').forEach(node => { node.textContent = ''; });
      form.querySelectorAll('[aria-invalid]').forEach(node => node.removeAttribute('aria-invalid'));
    };
    const fieldError = (name, message) => {
      const fields = Array.from(form.elements).filter(field => field.name === name && field.setAttribute);
      if (!fields.length) return;
      fields.forEach(field => field.setAttribute('aria-invalid', 'true'));
      const node = fields[0].closest('[data-sk-field]')?.querySelector('[data-sk-field-error]');
      if (node) node.textContent = message;
    };
    mode(); contactRequired(); updateRanks();
    rankFields.forEach(field => field.addEventListener('change', updateRanks));
    if (contact) contact.addEventListener('change', contactRequired);
    form.addEventListener('input', event => {
      const field = event.target;
      Array.from(form.elements).filter(input => input.name === field.name).forEach(input => input.removeAttribute('aria-invalid'));
      const node = field.closest('[data-sk-field]')?.querySelector('[data-sk-field-error]');
      if (node) node.textContent = '';
    });
    let busy = false, rememberedToken = null, rememberedFingerprint = null;
    const key = 'skinnovation:' + location.pathname + ':' + section.dataset.formType;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      clearErrors(); contactRequired();
      status.dataset.state = ''; status.textContent = '';
      let firstInvalid;
      Array.from(form.elements).forEach(field => {
        if (field.willValidate && !field.validity.valid) {
          fieldError(field.name, field.validity.valueMissing ? section.dataset.required : section.dataset.invalid);
          if (!firstInvalid) firstInvalid = field;
        }
      });
      if (firstInvalid) { firstInvalid.focus(); form.reportValidity(); return; }
      const choices = rankFields.map(field => field.value);
      if (new Set(choices).size !== choices.length) {
        status.dataset.state = 'error'; status.textContent = section.dataset.duplicate;
        return;
      }
      if (!section.dataset.endpoint) { status.dataset.state = 'error'; status.textContent = section.dataset.error; return; }
      busy = true; button.disabled = true; form.setAttribute('aria-busy', 'true');
      label.textContent = section.dataset.loading || 'Bezig met opslaan…';
      const data = Object.fromEntries(new FormData(form).entries());
      data.source_page = location.origin + location.pathname;
      data.user_agent = navigator.userAgent.slice(0, 1000);
      try {
        const fingerprint = JSON.stringify(data);
        if (fingerprint !== rememberedFingerprint) {
          rememberedToken = await submissionToken(data, key);
          rememberedFingerprint = fingerprint;
        }
        data.request_token = rememberedToken;
        const result = await postSubmission(section.dataset.endpoint, data, section.dataset.error);
        form.reset(); mode(); contactRequired(); updateRanks();
        status.dataset.state = 'success'; status.textContent = section.dataset.success;
        status.dataset.registrationId = result.registration_id;
        rememberedToken = null; rememberedFingerprint = null;
        try { sessionStorage.removeItem(key); } catch {}
      } catch (error) {
        status.dataset.state = 'error'; status.textContent = error.message || section.dataset.error;
        Object.entries(error.fieldErrors || {}).forEach(([name, message]) => fieldError(name, message));
        form.querySelector('[aria-invalid="true"]')?.focus();
      } finally {
        busy = false; button.disabled = false; form.removeAttribute('aria-busy'); label.textContent = buttonLabel;
      }
    });
  }
  const initAll = root => root.querySelectorAll('[data-sk-form-section]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
